<template>
  <div class="wrap-lg">
    <el-breadcrumb separator-class="el-icon-arrow-right" style="padding: 20px 0">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>报告验证</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card shadow="hover">
      <div>
        <el-input
          style="width: 380px;"
          class="inline-input"
          v-model="searchText"
          prefix-icon="el-icon-search"
          placeholder="报告编号"
        >
          <el-button slot="append">搜索</el-button>
        </el-input>
      </div>
    </el-card>
    <el-card style="margin-top: 10px;margin-bottom: 30px;">
      <el-table
        :data="tableData"
        border
        style="width: 100%">
        <el-table-column
          label="序号"
          align="center"
          type="index"
          width="80">
        </el-table-column>
        <el-table-column
          prop="name"
          label="企业名称">
        </el-table-column>
        <el-table-column
          prop="code"
          label="报告编号"
          width="180">
        </el-table-column>
        <el-table-column
          prop="result"
          label="检验结果">
   <!--       <template slot-scope="scope">
            <el-tag :type="scope.row.result | formatStatusType">{{scope.row.result | formatStatus}}</el-tag>
          </template>-->
        </el-table-column>
        <el-table-column
          prop="date"
          label="报告签发日期">
        </el-table-column>
        <el-table-column
          prop="address"
          label="样品名称">
        </el-table-column>
        <el-table-column
          prop="date"
          label="送检日期">
        </el-table-column>
      <!--  <el-table-column
          label="操作"
          align="center"
          width="120">
          <template >
            <el-button type="text">查看电子报告</el-button>
          </template>
        </el-table-column>-->
      </el-table>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      tableData: []
    }
  },
  filters: {
    formatStatus: function (val) {
      let statusArr = {
        '00': '待提交',
        '01': '待付款',
        '02': '已付款待审核',
        '03': '审核驳回',
        '04': '付款完成',
        '05': '拒受理',
        '06': '待发样品',
        '07': '待收样品',
        '08': '收样驳回',
        '09': '已收样待检验',
        '10': '检验中',
        '11': '检验完毕',
        '12': '待发送报告',
        '13': '已发送报告',
        '14': '客户反馈',
        '15': '回应反馈',
        '98': '完成',
        '99': '删除'
      }
      return statusArr[val]
    },
    formatStatusType: function (val) {
      if (['01', '05', '08'].includes(val)) {
        return ''
      } else if (['02', '07', '10'].includes(val)) {
        return 'success'
      } else if (['04', '09'].includes(val)) {
        return 'warning'
      } else if (['00', '03', '09'].includes(val)) {
        return 'danger'
      }
    },
    formatProgressType: function (val) {
      if (val <= 50) {
        return ''
      } else {
        return 'success'
      }
    }
  }
}
</script>

<style scoped>

</style>
